import { render } from "./PropertiesPanel.vue?vue&type=template&id=d9fe2d06&scoped=true"
import script from "./PropertiesPanel.vue?vue&type=script&lang=js"
export * from "./PropertiesPanel.vue?vue&type=script&lang=js"

import "./PropertiesPanel.vue?vue&type=style&index=0&id=d9fe2d06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9fe2d06"]])

export default __exports__